import { connect, ConnectedProps } from 'react-redux'
import TableAllCustomers from '../../../../../../../../specificComponents/Customers/TableAllCustomers'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../../../utils/reducers/company/employees'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../Modal'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'

type AllCustomersListingModalProps = ReduxTableAllCustomers & ModalEditComponentProps & {}

const AllCustomersListingModal: React.FC<AllCustomersListingModalProps> = ({ ...rest }) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TableAllCustomersConnect setTableInstance={() => { }} userPermissions={getUserPermissions('customer.profile.main') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)} />
        </ModalFullCentered>
    )
}

const tableAllCustomersDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

type ReduxTableAllCustomers = ConnectedProps<typeof tableAllCustomersConnect>
const mapTableAllCustomersConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const tableAllCustomersConnect = connect(mapTableAllCustomersConnector, tableAllCustomersDispatch)
const tableAllCustomersLoading = withLoading(TableAllCustomers, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const TableAllCustomersConnect = tableAllCustomersConnect(tableAllCustomersLoading)

export default AllCustomersListingModal